import { Pipe, PipeTransform } from '@angular/core';
import { PageService } from '../services/page.service';

@Pipe({
    name: 'realPageNumber',
    standalone: true
})
export class RealPageNumberPipe implements PipeTransform {

    constructor(private pageService: PageService) {
    }

    transform(indizes: number | Array<number>, args?: any): any {

        if (typeof indizes === 'number') {

            const realPageNumber = this.pageService.getRealPageNumber(indizes);

            if (realPageNumber <= 0) {
                return '';
            }

            return realPageNumber;
        }

        let realPageNumbers = (indizes as Array<number>).map(pageIndex => {
            return this.pageService.getRealPageNumber(pageIndex);
        });
        realPageNumbers = realPageNumbers.filter(ele => ele > 0);

        return realPageNumbers.join(' - ');
    }
}
